import React, { useEffect, useState } from 'react'
import { MegaMenu } from 'primereact/megamenu';
import BuTeamDashboard from './Bu-TeamDashboard';
import BuTeamRequestApproval from './Bu-TeamRequesApproval';
import BuUserWiseApproval from './Bu-UserWiseApproval';
 
const BuHead = () => {
const [currentTab, setCurrentTab] = useState(1);
  useEffect(() => {
  }, []);
  const menu1 = [
    {
      label: 'Dashboard',
      icon: 'pi pi-fw pi-file',
      command: () => setCurrentTab(1),
    },
    {
      label: 'Request Approval',
      icon: 'pi pi-pencil',
      command: () => setCurrentTab(2),

    },
    {
      label: 'User Wise Approval',
      icon: 'pi pi-fw pi-user',
      command: () => setCurrentTab(3),
    },
     
  ];
 
  return (
    <div className="tabview-demo">
      <div className="card mb-3">
      
        <MegaMenu model={menu1} />
      </div>
      <div className="flex grid">
         

        <div className="grid col-12" >
          {currentTab && currentTab == 1 && (

             <BuTeamDashboard />
          )}
          {currentTab && currentTab == 2 && (
             <BuTeamRequestApproval /> 
          )}
          {currentTab && currentTab == 3 && (
              <BuUserWiseApproval />
          )}

           
        </div>
      </div>
    </div >

  )

          }

 
 export default BuHead